<template>
  <slide-view v-model:toggle="main.active.args.toggle">
    <a-menu :items="menu" :inline-collapsed="main.active.args.toggle"
            v-model:open-keys="main.active.args.openKeys"
            :selected-keys="main.active.args.path" mode="inline" @select="main.onMenuChanged($event)"/>
  </slide-view>
</template>

<script setup lang="ts">

import SlideView from "@/views/share/SlideView.vue";
import {useRoute} from "vue-router";
import {Main} from "@/model/main";
import {computed} from "vue";
import {Material} from "@/model/material";
import {MenuItem} from "@/model/materials/tags";

const route = useRoute()
const main = route.meta.main as Main
const material = route.meta.material as Material

const menu = computed(() => {
  return material.tags.menus.map((item: MenuItem) => ({key:item.tag,label:material.tags.tags[item.tag].name,children:item.children.map((i:MenuItem) => ({key:i.tag,label:material.tags.tags[i.tag].name,data:i.children}))}))
})
</script>

<style scoped lang="sass">
:deep(.ant-menu-submenu-title > .ant-menu-title-content)
  font-weight: bolder
</style>